export const FEATURE_FLAGS = {
  multiTeams: "multi-teams",
  PARAGON_INTEGRATION: "paragon-integration",
  NEW_UPGRADE: "new-upgrade",
  EMBED_ZAPIER: "embed-zapier",
  TEAM_ONBOARDING_VIDEO_MODAL: "team-onboarding-video-modal",
  upgradeVersionControl: "upgrade-version-control-admin",
  purchaseVersionControl: "purchase-version-control-admin",
  subscriptionUpgradeVersionControl:
    "subscription-upgrade-version-control-admin",
  talkToSales: "talk-to-sales-admin",
  SHOP: "shop-admin",
};
